(function($) {
	'use strict';
	$.fn.Slide__PrevNext = function() {
		this.each(function() {

			/*
			 * Action: Trigger previous or next slide details or edit
			 */
			const $self = $(this),
						$triggers = $self.find('.prev,.next'),
						view_type = $self.data('type');


			// Listen for click
			$triggers.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

        // Vars
        const $this = $(this),
							$overlay = $this.closest('.slide--details'),
							inner_template = $('#slide--details--inner').html(),
							$current_slide = $('.component-slide-grid-item.active');


				// Current slide
				// Note: If this is in list view (view_type == 'list'), then we need to go search for our next slide item
				let $current_slide_container;
				if( 'list' === view_type ) {
					$current_slide_container = $current_slide.closest('.component-slide-list-item');
				}

				// Other vars
				let $next_grid_item,slide_data,new_inner_html;

				// Fade current content out
				$overlay.addClass('out');

        // Find our next slide for data
				// Note: If this is in list view (view_type == 'list'), then we need to go search for our next grid item
        if( $this.hasClass('next') ) {
          $next_grid_item = 'grid' === view_type ? $current_slide.next() : $current_slide_container.next().find('.component-slide-grid-item');
        } else {
          $next_grid_item = 'grid' === view_type ? $current_slide.prev() : $current_slide_container.prev().find('.component-slide-grid-item');
        }

				// If none left, just close overlay
				if( $next_grid_item.length === 0 ) {
					$('.close-overlay').trigger('click');
					$current_slide.removeClass('active');
					return;
				}

				// Activate Trigger (and clean siblings)
				$next_grid_item.addClass('active');
				$current_slide.removeClass('active');

				// Get options
			 	slide_data = JSON.parse( $next_grid_item.find('.slide-data').html() );

				// Parse and render
				Mustache.parse( inner_template );
				new_inner_html = Mustache.render( inner_template, slide_data );

				// Wait for content to be faded output
				setTimeout( () => {

					// Store var
					const $overlay_inner_holder = $overlay.find('.overlay-content');

					// Clear old content
					$overlay_inner_holder.find('.left,.right').remove();

					// Update current i number
					const next_i = 'grid' === view_type ? $next_grid_item.index() + 1 : $next_grid_item.closest('.component-slide-list-item').index();
					$self.find('.current').empty().html( next_i );

					// Add new content
					$overlay_inner_holder.prepend( new_inner_html );

					// Init new Controllers
					$overlay_inner_holder.find('[data-controller]').not('.instantiated').Instantiate();

					// Activate the first accordion item
					if( ! $overlay.hasClass('slide--edit') ) {
						$overlay.find('.accordion-trigger').first().trigger('click.accordion-trigger');
					}

					// Fade it back in
					setTimeout( () => {
						$overlay.removeClass('out');
					}, 100 );

				}, $.Globals.fxSpeed );


			});


		});
		return this;
	};
}(jQuery));
